import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const enterpriseSoftwareFaqs = [
  {
    question: 'What is the difference between ERP and CRM?',
    answer:
      'ERP connects core business operations such as finance, inventory, procurement, and production. CRM helps teams manage customer relationships, sales, marketing, and service. When integrated, the two systems give teams a more complete view of business performance and customer needs.',
  },
  {
    question: 'How do we choose the right ERP or CRM platform?',
    answer:
      'The right platform depends on your business processes, industry requirements, existing systems, growth plans, and budget. PT KCS helps assess these needs and compare suitable platforms so the decision is based on business fit rather than features alone.',
  },
  {
    question: 'Can PT KCS help with ERP and CRM implementation?',
    answer:
      'Yes. PT KCS supports implementation planning, requirements and process analysis, solution configuration, integrations, data migration, testing, deployment, and user enablement. The scope is tailored to your platform and project goals.',
  },
  {
    question: 'Can you migrate our existing ERP or CRM data?',
    answer:
      'Yes. We help plan and execute data migration by reviewing source data, mapping it to the target system, validating data quality, and testing migration results before go-live. The approach is designed to protect important business records and reduce disruption.',
  },
  {
    question: 'Can ERP and CRM systems connect with our other applications?',
    answer:
      'Yes. ERP and CRM platforms can be integrated with other business applications, data sources, and customer channels. We assess your current environment and design integrations that support reliable data exchange and useful end-to-end workflows.',
  },
  {
    question: 'Do you provide support after the system goes live?',
    answer:
      'PT KCS can continue to support your team after launch through system improvements, troubleshooting, optimization, and guidance as your business needs change. Ongoing support can be shaped around your internal capabilities and operational priorities.',
  },
];

export default function EnterpriseSoftwareFaqs() {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <section
      className="border-t px-5 py-16 sm:px-6 lg:px-10 lg:py-20"
      style={{ backgroundColor: '#FFFFFF', borderColor: '#DCE3EC' }}
      aria-labelledby="enterprise-software-faq-title"
    >
      <div className="mx-auto max-w-6xl">
        <h2
          id="enterprise-software-faq-title"
          className="text-center text-[32px] font-semibold leading-[48px]"
          style={{ color: '#183762' }}
        >
          Frequently Asked Questions
        </h2>
        <p
          className="mx-auto mt-5 max-w-4xl text-center text-base font-normal leading-[27px]"
          style={{ color: '#212121' }}
        >
          Answers to common questions about ERP and CRM consulting, implementation, and support.
        </p>

        <div className="mt-10 border-t" style={{ borderColor: '#DCE3EC' }}>
          {enterpriseSoftwareFaqs.map((faq, index) => {
            const isOpen = openFaq === index;
            const answerId = `enterprise-software-faq-answer-${index}`;

            return (
              <div key={faq.question} className="border-b" style={{ borderColor: '#DCE3EC' }}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenFaq(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    aria-controls={answerId}
                    className="flex w-full items-center justify-between gap-5 py-5 text-left text-base font-semibold sm:py-6 sm:text-lg"
                    style={{ color: '#183762' }}
                  >
                    {faq.question}
                    <ChevronDown
                      size={21}
                      className={`shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                      aria-hidden="true"
                    />
                  </button>
                </h3>
                <div id={answerId} hidden={!isOpen}>
                  <p
                    className="max-w-4xl pb-6 text-base font-normal leading-[27px]"
                    style={{ color: '#212121' }}
                  >
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
